import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { CompressAdapter } from "../../presentation/adpters/DecompressAdapter";

export class ESocialHttpGateway {
    HttpAdapter = new HttpAdapter();
    baseUrlDataSources = `${publicSettings.aws.baseUrls.dataSources}`;

    constructor() {}

    async importFiles({ accountingId, companyId, userId, files } = {}) {
        if (!accountingId || !userId || !files)
            return { error: "Missing params!" };
        try {
            const params = {
                accountingId,
                ...(companyId && { companyId }),
                userId,
                files
            };
            return await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/import`,
                params
            );
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }

    async sendCertificate({
        accountingId,
        certificate,
        connectedBy,
        origin
    } = {}) {
        try {
            if (!accountingId || !certificate) return false;
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/send-certificate`,
                {
                    accountingId,
                    certificate,
                    connectedBy,
                    origin
                }
            );
            if (response?.message) {
                if (response.success) {
                    return true;
                } else {
                    return response;
                }
            }
            return true;
        } catch (err) {
            console.log(`Error send certificate: ${err}`);
            return err;
        }
    }

    async getRequests({ accountingId, companyId } = {}) {
        try {
            if (!accountingId || !companyId) return [];
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/get-requests`,
                {
                    accountingId,
                    companyId
                }
            );
            return response?.requests || [];
        } catch (err) {
            return [];
        }
    }

    async getAuthorizationTerm({ accountingId, document, socialName }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlDataSources}/serpro/generate-authorization-term`,
            {
                accountingId,
                document,
                socialName
            }
        );

        return response;
    }

    async integrateCompany({
        accounting = { _id: "", document: "" },
        company = { _id: "", document: "" },
        userId = "",
        period = { start: {}, end: {} }
    }) {
        const input = {
            accountingId: accounting?._id,
            accountingDocument: accounting?.document,
            companyId: company?._id,
            companyDocument: company?.document,
            userId: userId
        };
        if (
            !input.accountingId ||
            !input.companyId ||
            !input.accountingDocument ||
            !input.companyDocument ||
            !input.userId
        )
            return false;
        const response = await this.HttpAdapter.call(
            `${this.baseUrlDataSources}/esocial/company-connect`,
            input
        );

        return response;
    }

    async requestCompany(accountingId) {
        if (!accountingId) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/request-company-list`,
                {
                    accountingId
                }
            );
            return response;
        } catch (err) {
            console.error(`Error request company: ${err}`);
            return false;
        }
    }

    async updateCompany({ accounting, company, userId }) {
        const input = {
            accountingId: accounting?._id,
            accountingDocument: accounting?.document,
            companyId: company?._id,
            companyDocument: company?.document,
            userId
        };
        const response = await this.HttpAdapter.call(
            `${this.baseUrlDataSources}/esocial/update-events`,
            input
        );
        return response;
    }

    async getEvents({ companyId, period } = {}) {
        try {
            if (!companyId || !period) return [];
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/get-events-by-company`,
                {
                    companyId,
                    period
                }
            );

            return await CompressAdapter.decompres(response);
        } catch (err) {
            console.error(`Erro ao obter eventos ou descomprimir: ${err}`);
            return {};
        }
    }

    async recalculatePointsByCompany({ accountingId, companyId } = {}) {
        try {
            if (!accountingId || !companyId) {
                return { success: false, message: "Parâmetros obrigatórios não fornecidos" };
            }
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/recalculate-points-by-company`,
                { accountingId, companyId }
            );
            if (response.name === 'Error') {
                throw new Error(response.message || "Erro ao recalcular dados da empresa");
            }
            return response;
        } catch (err) {
            throw new Error(err.message || "Erro ao recalcular dados da empresa");
        }
    }

    async requestCertificateValidation({ accountingId, userId } = {}) {
        try {
            if (!accountingId || !userId) {
                return {
                    success: false,
                    message: "Parâmetros obrigatórios não fornecidos"
                };
            }

            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataSources}/esocial/send-validate-certificate`,
                {
                    accountingId,
                    userId
                }
            );

            return response;
        } catch (err) {
            console.error(`Erro ao solicitar validação de certificado: ${err}`);

            // Tratamento específico para erro de CORS (endpoint não disponível)
            if (err.message && err.message.includes("Failed to fetch")) {
                return {
                    success: false,
                    message:
                        "Endpoint temporariamente indisponível. Tente novamente mais tarde."
                };
            }

            return { success: false, message: "Erro interno do servidor" };
        }
    }
}
